import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { HttpBaseService, SnackbarMsgService } from 'app/shared/services';
import { forkJoin, tap } from 'rxjs';
import { UserService } from 'app/core/user/user.service';
import { AuthService } from 'app/core/auth/auth.service';
import { IAuthData, IRenewData, SsoIntegrator, HttpMethodEnum, IUserAuth } from './@shared';
import { environment } from 'environments/environment';
import { AuthUtils } from 'app/core/auth/auth.utils';
import { UserSimple } from 'app/shared';
import { IdpRoleEnum } from '../admin/users';

@Injectable({
  providedIn: 'root'
})
export class AuthApiService extends HttpBaseService {

  constructor(
    private _userService: UserService,
    private _authService: AuthService,
  ) {
    super(inject(HttpClient), inject(SnackbarMsgService));
  }

  postCredentials(applicationId: string, clientId: string, username: string, password: string) {
    const body = {
      applicationId,
      clientId,
      username,
      password
    };

    return this._http.post<IAuthData>(`${environment.apiUrl}auth`, body)
      .pipe(
        this._handleError(false, true)
      );
  }

  forgotPassword(email: string, applicationId: string) {
    return this._http.post<void>(`${environment.apiUrl}auth/forgot-password`, { email, applicationId })
      .pipe(
        this._handleError(false, true)
      );
  }

  resetPassword(password: string, token: string, applicationId: string) {
    return this._http.post<void>(`${environment.apiUrl}auth/reset-password`, { password, token, applicationId })
      .pipe(
        this._handleError(false, true)
      );
  }

  renewToken(token: string) {
    return this._http.post<IRenewData>(`${environment.apiUrl}auth/renew`, { token }).pipe(
      this._handleError(false, true),
      tap(data => {
        if (!data) {
          return;
        }

        this._authService.accessToken = data.accessToken || '';

        this._authService.refreshToken = data.refreshToken || '';
      })
    )
  }

  revokeToken(token: string) {
    return this._http.post<void>(`${environment.apiUrl}auth/revoke`, { token })
      .pipe(
        this._handleError(false, true)
      );
  }

  postPin(token: string, pin: string) {
    return this._http.post<IAuthData>(`${environment.apiUrl}auth/mfa-pin`, { token, pin })
      .pipe(
        this._handleError(false, true)
      );
  }

  authorize(accessToken: string, refreshToken: string) {
    if (!accessToken || !refreshToken) return;

    const decodedToken = AuthUtils.decodeToken(accessToken);

    const user: UserSimple = {
      id: decodedToken.sub || '',
      name: decodedToken.name || '',
      email: decodedToken.email || '',
      cpf: decodedToken.unique_name || '',
      permissions: decodedToken.permissions || [],
      roles: decodedToken.roles || [],
      idpRole: decodedToken.idpRole || IdpRoleEnum.User,
    }

    this._userService.user = user;
    this._authService.accessToken = accessToken;
    this._authService.refreshToken = refreshToken;
    this._authService.lastApplicationId = decodedToken.aud || '';

  }
}
